import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import Payments from './Payments';

// Define interface for the props that Payments component expects
interface PaymentsCompProps {
  canAdd: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

const PaymentsPage: React.FC = () => {
  const { canView, canAdd, canEdit, canDelete } = usePermissions();

  if (!canView('payments')) {
    return null;
  }

  // Use type assertion to tell TypeScript that Payments accepts these props
  const PaymentsComp = Payments as React.ComponentType<PaymentsCompProps>;

  return (
    <PaymentsComp
      canAdd={canAdd('payments')}
      canEdit={canEdit('payments')}
      canDelete={canDelete('payments')}
    />
  );
};

export default PaymentsPage; 